import { render, staticRenderFns } from "./PeriodFilter.vue?vue&type=template&id=228a5add"
import script from "./PeriodFilter.vue?vue&type=script&lang=js"
export * from "./PeriodFilter.vue?vue&type=script&lang=js"
import style0 from "./PeriodFilter.vue?vue&type=style&index=0&id=228a5add&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228a5add')) {
      api.createRecord('228a5add', component.options)
    } else {
      api.reload('228a5add', component.options)
    }
    module.hot.accept("./PeriodFilter.vue?vue&type=template&id=228a5add", function () {
      api.rerender('228a5add', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/components/Calendar/PeriodFilter.vue"
export default component.exports